function initSkipLink(container) {
    const anchor = container.querySelector('.skip-link__anchor');
    if (!anchor) return;

    const handleScroll = () => {
        const containerRect = container.getBoundingClientRect();
        const scrollLimit = container.offsetHeight / 2;

        if (containerRect.top < scrollLimit) {
            container.classList.remove('is-active');
            window.removeEventListener('scroll', handleScroll);
        }
    };

    anchor.addEventListener('focus', () => {
        container.classList.add('is-active');
        window.addEventListener('scroll', handleScroll);
    });

    anchor.addEventListener('blur', () => {
        container.classList.remove('is-active');
        window.removeEventListener('scroll', handleScroll);
    });
}

document.querySelectorAll('.skip-link').forEach(initSkipLink);
